module.exports = function(video) {
	'use strict'
  video
  .controller('videoTagsController', videoTagsController)
	videoTagsController.$inject = ["watchAllCheckboxesNgTable","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","postDataService","alertService", "deleteDataService","putDataService","serverError","comunicateBetweenViews", "offlineError"]
	
  function videoTagsController(watchAllCheckboxesNgTable,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,refreshtokenService, postDataService,alertService, deleteDataService, putDataService,serverError, comunicateBetweenViews, offlineError) {
    var vmvt = this;
    vmvt.tagEdit = false;
    var state = 'video-tags';
    var page;  
    var s;
    var $data;
    $rootScope.alert={hasBeenShown: false};
    $rootScope.hasLoaded = false;
    vmvt.selectedName = -1;
    vmvt.hasParent = {items:{}};
    vmvt.tagName = undefined;
    vmvt.tagSlug = undefined;
    vmvt.tagDescription= undefined;
    vmvt.selectedBulkAction = {value: 'default'};
    vmvt.checkedPostsEdit = [];
    vmvt.checkboxes = { 'checked': false, items: {} };
    $rootScope.emptyTable = false;
    vmvt.tagId = $stateParams.id; 
    if($stateParams.id) {
      vmvt.tagEdit= true;
    } else {
      vmvt.tagEdit = false;
    }
    vmvt.goToAllPosts = function(tag) {
      comunicateBetweenViews.setTag(tag);
      $state.go('app.allvideos'); 
    }
    vmvt.editTag = function(tagId,tagCount) {
      vmvt.tagEdit= true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 10);
      vmvt.tagId = tagId;
      $state.transitionTo('app.video_tags', {id: vmvt.tagId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmvt.addNewTag = function() {

      if(vmvt.tagName) {
        $rootScope.hasLoaded = false;
        var postFunction = function() {
          postDataService.save({
            param1:state
          },{
            'name':vmvt.tagName,
            "description": vmvt.tagDescription,
            'slug':vmvt.tagSlug
          }).$promise.then(function(postTag){ 
            vmvt.tagName = undefined;
            vmvt.tagSlug = undefined;
            vmvt.tagDescription= undefined;
            alertService('success','Success ', postTag.message, 2000);
            $rootScope.hasLoaded = true;
            vmvt.tableReloadFunction(vmvt.tableParams.page());
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              if(error && error.data && error.data.error && error.data.error.slug) {
                vmvt.tagSlug = error.data.error.slug;
              }
            }
            $rootScope.hasLoaded = true;  
          });
        }
        postFunction();
      } else {
        alertService('danger','Opps! ', 'Tag is required')
        vmvt.nameRequired=true;
      }
    }
   
    vmvt.quickEdit = function(id) {
      vmvt.selectedName = id;
    }
    vmvt.cancelQuickEdit = function() {
      vmvt.selectedName = -1;
    }
    vmvt.reloadTable = function() {
      vmvt.tableParams.reload()
    }
    vmvt.updateBulkDeleteSuccess = function() {
      watchAllCheckboxesNgTable.resetCheckBox(vmvt)
      vmvt.selectedBulkAction = {value: 'default'};
      vmvt.tableParams.reload(); 
    }
    watchAllCheckboxesNgTable.watch($scope,vmvt)
    vmvt.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmvt.checkedPostsEdit.push(categoryId);
      } else {

        if(vmvt.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmvt.checkedPostsEdit.indexOf(id_tag);
          vmvt.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    vmvt.tableActionsFunction = function(params) {
      vmvt.search =function(value) {
        if(value) {  
          s = value.toLowerCase();
        } else {
          s = null;
        }
        page = 1;
        params.page(page);
        vmvt.tableParams.reload();
      }
    }
    vmvt.tableReloadFunction = function(page) {
      vmvt.tableParams = new NgTableParams({
        page: page || 1,
        count: 20,
              
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            page: params.page(),
            limit: params.count(),
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            s:s
            }).$promise.then(function(data){
           
            $rootScope.hasLoaded = true;
            $data =data.tags;
            vmvt.dataGet = data.tags;
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            if(data.tags.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            }
            watchAllCheckboxesNgTable.resetCheckBox(vmvt)
            vmvt.tableActionsFunction(params);  
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
                if(answer==200) {
                  vmvt.tableReloadFunction(params.page());
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.'); 
            }
            $rootScope.hasLoaded = true;
            vmvt.tableActionsFunction(params);
          });
        }    
      });   
    }
    vmvt.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-tags/js/videoTagsController.js
// module id = 657
// module chunks = 0